"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useRegistrationWrapper = useRegistrationWrapper;
var _auth = require("@ori/auth");
var _checkoutUtils = require("@ori/checkout-utils");
var _configurationManager = require("@ori/configuration-manager");
var _environment = require("@ori/environment");
var _i18n = require("@ori/i18n");
var _shoppingContext = require("@ori/shopping-context");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _react = require("react");
var _api = require("../../api");
var _constants = require("../../constants");
var _contexts = require("../../contexts");
var _utils = require("../../utils");
const { logDebug } = (0, _checkoutUtils.getLoggers)(_constants.PACKAGE_NAME);
function useRegistrationWrapper() {
    const configuration = (0, _contexts.useCheckout)();
    const { registrationId, onRegistrationClose, setRegistrationId } = (0, _contexts.useNavigationContext)();
    const { shoppingContext: { referral = null } = {} } = (0, _shoppingContext.useShoppingContext)();
    var _jsCookie_default_get;
    const referralCode = (_jsCookie_default_get = _jsCookie.default.get('pbs_owner')) !== null && _jsCookie_default_get !== void 0 ? _jsCookie_default_get : '';
    const { tenant } = (0, _environment.useEnvironment)();
    const { language } = (0, _i18n.useLanguage)();
    const { globalApiUrl, identityUrl, staticApiUrl } = (0, _configurationManager.useServiceUrls)([
        'globalApi',
        'identity',
        'staticApi'
    ]);
    var _referral_sponsorId;
    const { consultantNumber, isConsultantNumberLoading } = (0, _api.useGetConsultantNumber)({
        customerId: (_referral_sponsorId = referral === null || referral === void 0 ? void 0 : referral.sponsorId) !== null && _referral_sponsorId !== void 0 ? _referral_sponsorId : _auth.NOT_LOGGED_IN_USER_ID,
        tenant
    });
    (0, _react.useEffect)(()=>{
        if (!registrationId) {
            const sessionRegistrationId = _jsCookie.default.get('registrationId');
            if (sessionRegistrationId) {
                setRegistrationId(sessionRegistrationId);
            }
        }
    }, [
        registrationId,
        setRegistrationId
    ]);
    const handleCallbackRegistrationId = (0, _react.useCallback)((formRegistrationId)=>{
        _jsCookie.default.set('registrationId', formRegistrationId);
        setRegistrationId(formRegistrationId);
        logDebug('handleCallbackRegistrationId called and registrationId is saved to session storage.\n\tCurrent registration id:', formRegistrationId);
    }, [
        setRegistrationId
    ]);
    const customerReferral = (0, _utils.getCustomerReferral)(referral, referralCode, consultantNumber);
    const registrationConfiguration = {
        autoLoginUrl: '/system/UI/SsoIdentity/Autologin',
        globalApiUrl,
        identityUrl,
        currentLanguage: language,
        loginUrl: '/ssoidentity/Login',
        staticApiUrl,
        tenant,
        registrationID: registrationId,
        customerReferral,
        ...configuration
    };
    return {
        handleCallbackRegistrationId,
        isConsultantNumberLoading,
        onRegistrationClose,
        registrationConfiguration
    };
}
